package io.horion.cv.api.datasource.cv

import kotlinx.serialization.Serializable

@Serializable
data class Competence(
    val name: String,
    val level: Level = Level.BEGINNER // 0.0 à 1.0
)
